export default __webpack_public_path__ + "static/illu_weiterverarbeitung-dad0bc860148f57d6c23e36fd9869568.svg";